var categories = [];

jQuery(document).ready(function () {
  initialize_categories();
  search();
  category_selection();

  /* hover-links.js */
  var headers = jQuery(".category_title");
  headers.each((index, element) => {
    add_link_hover(element);
  });
  if (jQuery("#faq_content").length > 0)
    include_copied_text_badge("#faq_content");

  jQuery(window).on("load", function () {
    if (jQuery(".blog_taxonomy_section").length > 0) {
      blog_taxonomy_section();
    }
  });
});


function get_categories() {
  jQuery("#faq_categories li a").each(function () {
    let slug = jQuery(this).attr("data-filter");
    let title = jQuery(this).attr("data-title");
    categories.push([slug, title]);
    jQuery(this).click(function () {
      filter_by_category(slug, title);
    });
  });
  console.log(categories);

  var first = categories[0];
  console.log(first);
  filter_by_category(first[0], first[1]);

  // First one opened
  first_opened(first[0]);
}

function category_selection() {
  jQuery("#faq_categories").change(function () {
    var optionSelected = jQuery(this).find("option:selected");
    // Hide search box if category is selected
    if (jQuery(optionSelected).attr("value") != "all") {
      jQuery("#search_term").prop("disabled", true);
    } else {
      jQuery("#search_term").prop("disabled", false);
    }
    // Hide the rest or show all
    console.log("value " + jQuery(optionSelected).attr("value"));
    filter_by_category(jQuery(optionSelected).attr("value"));
  });
}

function filter_by_category(slug) {
  //jQuery('.category_title').text(title);
  console.log(slug);
  jQuery(".category").each(function () {
    if (slug === "all") {
      jQuery(this).show(600, "swing");
    } else {
      if (jQuery(this).attr("data-filter") !== slug) {
        jQuery(this).hide(100, "swing");
      } else {
        jQuery(this).show(600, "swing");
      }
      // First one opened
      first_opened(slug);
    }
  });
}

function first_opened(category) {
  // First one opened
  jQuery('.accordion_item[data-filter="' + category + '"][data-order="1"]')
    .addClass("open")
    .find(".accordion_content")
    .show();
  console.log(
    '.accordion_item[data-filter="' + category + '"][data-order="1"]'
  );
}

function initialize_categories() {
  jQuery(".accordion_item").each(function () {
    jQuery(this).find(".accordion_content").hide();
    jQuery(this).click(function () {
      //jQuery(this).find('.accordion_content').toggle(400, 'swing');
      if (jQuery(this).hasClass("open")) {
        jQuery(this)
          .removeClass("open")
          .find(".accordion_content")
          .hide(400, "swing");
      } else {
        jQuery(this)
          .addClass("open")
          .find(".accordion_content")
          .show(400, "swing");
      }
    });
  });
}

function search() {
  var search_str = "";
  jQuery("#search_term").on("keyup", function (event) {
    search_str = jQuery("#search_term").val();

    // Hide titles if no questions are displayed
    let count_categories = jQuery(".category").length;
    jQuery(".category").each(function () {
      // ToDo Search category titles
      /*if(jQuery(this).find('.category_title').text().match(search_str)) {

      }*/
      let count_questions = 0;
      // Search inside questions content
      jQuery(this)
        .find(".accordion_item")
        .each(function () {
          if (!jQuery(this).text().match(new RegExp(search_str, "i"))) {
            jQuery(this).hide(400, "swing");
            count_questions++;
          } else {
            jQuery(this).show(400, "swing");
          }
        });

      if (count_questions === jQuery(this).find(".accordion_item").length) {
        jQuery(this).hide(400, "swing");
        count_categories--;
      } else {
        jQuery(this).show(400, "swing");
        count_categories++;
      }
    });

    // Show no results if all titles are hide
    count_categories === 0
      ? jQuery(".no_results").show(400, "swing")
      : jQuery(".no_results").hide(400, "swing");

    console.log(search_str);
  });
}
